/**
 * Lightweight AppSync GraphQL client using fetch.
 * Authenticates with the Cognito ID token from the current session.
 */

const APPSYNC_URL = import.meta.env.VITE_APPSYNC_URL;

export async function graphqlRequest<T = unknown>(
  query: string,
  variables: Record<string, unknown>,
  idToken: string,
): Promise<T> {
  const res = await fetch(APPSYNC_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: idToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const json = await res.json();

  if (json.errors?.length) {
    throw new Error(json.errors[0].message);
  }

  return json.data;
}
